import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";

/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import 'quasar/dist/quasar.ie.polyfills.js';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'; // We load Quasar stylesheet file

import 'quasar/dist/quasar.styl';
import 'src/css/app.styl';
import '@quasar/quasar-app-extension-qpdfviewer/src/component/pdfviewer.sass';
import Vue from 'vue';
import createApp from "./app.js";
import qboot_Bootaxios from 'boot/axios';
import qboot_Bootpermission from 'boot/permission';
import qboot_BootstandardInputControls from 'boot/standardInputControls';
import qboot_BootreadOnly from 'boot/readOnly';
import qboot_Bootnotifydefaults from 'boot/notify-defaults';
import qboot_BootuserData from 'boot/userData';
import qboot_Quasarquasarappextensionqpdfviewersrcbootqpdfviewerjs from '@quasar/quasar-app-extension-qpdfviewer/src/boot/qpdfviewer.js';

function start() {
  return _start.apply(this, arguments);
}

function _start() {
  _start = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _ref, app, router, routeUnchanged, redirect, urlPath, bootFiles, i;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createApp();

          case 2:
            _ref = _context.sent;
            app = _ref.app;
            router = _ref.router;
            routeUnchanged = true;

            redirect = function redirect(url) {
              routeUnchanged = false;
              window.location.href = url;
            };

            urlPath = window.location.href.replace(window.location.origin, '');
            bootFiles = [qboot_Bootaxios, qboot_Bootpermission, qboot_BootstandardInputControls, qboot_BootreadOnly, qboot_Bootnotifydefaults, qboot_BootuserData, qboot_Quasarquasarappextensionqpdfviewersrcbootqpdfviewerjs];
            i = 0;

          case 10:
            if (!(routeUnchanged === true && i < bootFiles.length)) {
              _context.next = 28;
              break;
            }

            if (!(typeof bootFiles[i] !== 'function')) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("continue", 25);

          case 13:
            _context.prev = 13;
            _context.next = 16;
            return bootFiles[i]({
              app: app,
              router: router,
              Vue: Vue,
              ssrContext: null,
              redirect: redirect,
              urlPath: urlPath
            });

          case 16:
            _context.next = 25;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](13);

            if (!(_context.t0 && _context.t0.url)) {
              _context.next = 23;
              break;
            }

            window.location.href = _context.t0.url;
            return _context.abrupt("return");

          case 23:
            console.error('[Quasar] boot error:', _context.t0);
            return _context.abrupt("return");

          case 25:
            i++;
            _context.next = 10;
            break;

          case 28:
            if (!(routeUnchanged === false)) {
              _context.next = 30;
              break;
            }

            return _context.abrupt("return");

          case 30:
            new Vue(app);

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 18]]);
  }));
  return _start.apply(this, arguments);
}

start();